<template>
    <div>
        <v-flex xs12 sm12 d-block class="card-dados">
            <h3 class="card-dados__titulo">Lance de Desempate {{ compraDireta.situacao === 'SUSPENSA' ? ' (Suspenso)' : '' }}</h3>
            <v-data-table :headers="colunas"
                          :items="itemLoteDesempate"
                          item-key="rankingId"
                          hide-actions
                          no-data-text="Não há itens/lote em processo de desempate"
                          class="az-table-list tabela-lances">
                <template slot="items" slot-scope="props">
                    <tr :key="props.item.rankingId">
                        <td>
                            {{ props.item.sequencial }}
                        </td>
                        <td>
                            <expansao-texto :tamanho="tamanho" :texto="props.item.descricao"/>
                        </td>
                        <td class="text-capitalize">
                            Empatado
                        </td>
                        <td>
                            <span v-if="compraDireta.situacao === 'SUSPENSA'" class="text-capitalize">Suspenso</span>
                            <count-down-desempate v-if="compraDireta.situacao !== 'SUSPENSA'"
                                                  :key="props.item.rankingId"
                                                  :data-hora-atual="props.item.dataHoraAtual"
                                                  :data-hora-fim-desempate="props.item.dataHoraFimDesempate"
                                                  @tempoDesempateEncerrado="tempoDesempateEncerrado(props.item)"/>
                        </td>
                        <td align="right">
                            {{ props.item.valor | cdCurrency(prefixo, quantidadeCasasDecimais) }} {{ sufixo }}
                        </td>
                        <td>
                            <div class="pl-2 d-flex justify-space-between">
                                <az-money v-model="props.item.valorDesempate"
                                          :disabled="props.item.lanceJaEnviado || !props.item.estaEmDesempate || compraDireta.situacao === 'SUSPENSA'"
                                          :maxLength="18"
                                          :precision="quantidadeCasasDecimais"
                                          :placeholder="placeholderValor"
                                          :prefix="prefixo"
                                          :suffix="sufixo"
                                          @blur="props.item.valorDesempate = $event"
                                          @keyupEnter="efetuarLanceDesempate($event, props.item)"
                                          class="pt-0 alinhar-direita"/>

                                <az-call-to-action id="botaoEnviarLannceDesempate"
                                                   v-if="!props.item.lanceJaEnviado && props.item.estaEmDesempate"
                                                   css-class="botao-enviar-lance-desempate text-uppercase desabilitado"
                                                   :disabled="compraDireta.situacao === 'SUSPENSA'"
                                                   @click="efetuarLanceDesempate(props.item.valorDesempate, props.item)">
                                    Enviar
                                </az-call-to-action>
                                <az-call-to-action id="botaoCancelarDesempate"
                                                   v-else-if="props.item.lanceJaEnviado && props.item.estaEmDesempate"
                                                   css-class="botao-cancelar-lance-desempate text-uppercase desabilitado"
                                                   color="error"
                                                   @click="exibirModalCancelarLance(props.item)">
                                    Cancelar
                                </az-call-to-action>
                            </div>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>

        <div class="az-actions-form acao-botao">
            <botao-voltar @voltar="irParaDocumentoPropostaDoFornecedor"/>
        </div>

        <lance-desempate-modal-cancelar :exibirModal="mostrarDialogoCancelar"
                              :item="item"
                              :casasDecimais="quantidadeCasasDecimais"
                              :prefix="prefixo"
                              :suffix="sufixo"
                              @fechar="fecharModalCancelarLance"
                              @cancelarLance="tratarEventoCancelarLance"/>

        <modal-compra-suspensa :exibirModal="mostrarModalSuspensao"
                              @fechar="fecharModalSuspensao"/>
    </div>
</template>

<script>
import SmartTimerMixin from '@/core/mixins/SmartTimerMixin'
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'
import LanceDesempateModalCancelar from './LanceDesempateModalCancelar'
import ModalCompraSuspensa from './ModalCompraSuspensa'
import CountDownDesempate from '@/views/components/CountDownDesempate'
import BotaoVoltar from '@/views/components/BotaoVoltar'
import ExpansaoTexto from '@/views/components/ExpansaoTexto'

export default {
    name: 'LanceDesempate',
    mixins: [SmartTimerMixin],
    components: {
        ExpansaoTexto,
        BotaoVoltar,
        CountDownDesempate,
        LanceDesempateModalCancelar,
        ModalCompraSuspensa
    },
    data() {
        return {
            compraDiretaId: null,
            propostaId: null,
            tamanho: null,
            colunas: [
                {
                    value: 'sequencia',
                    sortable: true,
                    width: '5%',
                    text: 'Seq',
                    class: 'primary--text',
                    align: 'left'
                },
                {
                    value: 'descricao',
                    sortable: false,
                    width: '35%',
                    text: 'Descrição',
                    class: 'primary--text',
                    align: 'left'
                },
                {
                    value: 'situacao',
                    sortable: false,
                    width: '10%',
                    class: 'primary--text',
                    text: 'Situação',
                    align: 'left',
                },
                {
                    value: 'tempo',
                    width: '10%',
                    text: 'Tempo',
                    sortable: false,
                    class: 'primary--text',
                    align: 'left'
                },
                {
                    align: 'center',
                    sortable: false,
                    text: 'Valor',
                    value: 'valor',
                    width: '15%',
                    class: 'primary--text'
                },
                {
                    align: 'center',
                    sortable: false,
                    text: 'Enviar Valor',
                    value: 'valorDesempate',
                    width: '25%',
                    class: 'primary--text'
                }
            ],
            mostrarDialogoCancelar: false,
            mostrarModalSuspensao: false,
            item: {},
            lanceDesempate:{
                compraDiretaId: null,
                itensLotes: [],
                quantidadeEmpatados: 0,
            }
        }
    },
    computed: {
        ...mapState(['compraDireta', 'compraDiretaSuspensa']),
        quantidadeCasasDecimais() {
            return this.compraDireta.casaDecimal
        },
        prefixo() {
            if (this.compraDireta.criterioJulgamento === 'MENOR_PRECO')
                return 'R$'
            return ''
        },
        sufixo() {
            if (this.compraDireta.criterioJulgamento === 'MAIOR_DESCONTO')
                return '%'
            return ''
        },
        placeholderValor() {
            if (this.compraDireta.criterioJulgamento === 'MAIOR_DESCONTO')
                return 'Desconto. Ex: 5.00%'
            return 'Valor. Ex: R$ 10.00'
        },
        itemLoteDesempate() {
            return this.lanceDesempate.itensLotes
        }
    },
    async created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    async mounted() {
        try {
            this.setCompraDiretaIdEPropostaId()
            await this.buscarLances()
            this.desabilitarLoadingGlobal()

            this.createSmartTimer('buscarLances', 'buscarLances', 10000, {
                autostart: true,
                immediate: true
            })
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarLances() {
            try {
                const lances = await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_ITEM_LOTE_LANCES_DESEMPATE, this.compraDiretaId)
                this.lanceDesempate = { ...lances }
                await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_DETALHES_DA_COMPRA_DIRETA, this.compraDiretaId)
                if (this.compraDireta && this.compraDireta.situacao === 'SUSPENSA') {
                    this.stopSmartTimer('buscarLances')
                    this.mostrarModalSuspensao = true
                }
            } catch (error) {
                this.mostrarNotificacaoErro('Erro ao buscar lances: ' + error.message)
            }
        },
        async efetuarLanceDesempate(novoValor, item) {
            if (novoValor === null) {
                throw new Error('Não é possível enviar um valor vazio.')
            }
            if (novoValor >= 10000000000) {
                throw new Error('Não é possível enviar um valor acima de 10 bilhões de reais.')
            }
            const objetoComboParametros = {
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId,
                rankingId: item.rankingId,
                itemCompraDiretaId: item.itemCompraDiretaId,
                loteCompraDiretaId: item.loteCompraDiretaId,
                tipo: item.tipo,
                valor: item.valorDesempate
            }
            this.habilitarLoadingGlobal()
            this.setMensagemLoading('Efetuando Lance...')
            await this.$store.dispatch(actionTypes.FORNECEDOR.EFETUAR_LANCE_DESEMPATE, objetoComboParametros)
            const valor = this.$options.filters.cdCurrency(novoValor, this.prefixo,this.quantidadeCasasDecimais)+this.sufixo
            this.mostrarNotificacaoSucesso(`Lance de ${valor} efetuado com sucesso!`)
            this.desabilitarLoadingGlobal()
            await this.buscarLances()
        },
        async tratarEventoCancelarLance() {
            const itemObj = {
                id: this.item.lanceId,
                compraDiretaId: this.compraDiretaId,
                rankingId: this.item.rankingId,
                tipo: this.item.tipo
            }
            this.fecharModalCancelarLance()
            await this.$store.dispatch(actionTypes.FORNECEDOR.CANCELAR_LANCE_DESEMPATE, itemObj)
            this.mostrarNotificacaoSucesso('Lance cancelado com sucesso.')
            await this.buscarLances()
        },
        exibirModalCancelarLance(item) {
            this.item = item
            this.mostrarDialogoCancelar = true
        },
        fecharModalCancelarLance() {
            this.mostrarDialogoCancelar = false
            this.item = {}
        },
        fecharModalSuspensao() {
            this.mostrarModalSuspensao = false
        },
        setCompraDiretaIdEPropostaId() {
            this.compraDiretaId = this.$route.params.id
            this.propostaId = this.$route.params.propostaId
        },
        pegarTamanho() {
            this.tamanho = .09 * window.innerWidth
        },
        irParaDocumentoPropostaDoFornecedor() {
            this.$router.push({
                name: 'DocumentoPropostaDoFornecedor',
                params: {
                    id: this.compraDiretaId,
                    propostaId: this.propostaId
                }
            })
        },
        tempoDesempateEncerrado(item){
            item.estaEmDesempate = false
            const timeOut = setTimeout(async () => {
                await this.buscarLances()
                clearTimeout(timeOut)
            }, 2500)
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    }
}
</script>

<style scoped>
.legenda {
    font-size: 13px;
    color: #777;
}

.botao-enviar-lance-desempate.v-btn--outline {
    background-color: var(--v-primary-base) !important;
    color: #fff !important;
    padding: 0;
    border: 1px solid var(--v-primary-base) !important;
    border-radius: 2px;
    max-height: 34px;
    margin-left: 10px;
    margin-right: 0;
    min-width: 70px;
    max-width: 70px;
    font-size: 12px;
}

.botao-cancelar-lance-desempate.v-btn--outline {
    background-color: red !important;
    color: #fff !important;
    padding: 0;
    border: 1px solid red !important;
    border-radius: 2px;
    max-height: 34px;
    margin-left: 10px;
    margin-right: 0;
    min-width: 70px;
    max-width: 70px;
    font-size: 12px;
}

.botao-enviar-lance-desempate[disabled],
.botao-cancelar-lance-desempate[disabled] {
    opacity: .5;
}

.tabela-lances {
    border: 0 solid #bebebe;
    margin: 0 16px 16px;
}

.tabela-lances td,
.tabela-lances thead tr th {
    border-right: 0 solid #e7e7e7;
}

.tabela-lances tr {
    border-bottom: 1px solid #e7e7e7 !important;
}

.tabela-lances td:last-child,
.tabela-lances thead tr th:last-child {
    border-right: 0;
}

.tabela-lances tr:last-child {
    border-bottom: 0 !important;
}

.tabela-lances thead tr {
    height: 30px !important;
}

.tabela-lances .texto-valor {
    text-align: right;
    display: inline-block;
}

.icone-empatado {
    background-color: rgba(0, 0, 0, .54);
    color: #fff;
    font-size: 10px;
    padding: 1px 5px;
    border-radius: 50%;
    font-weight: bold;
    cursor: default;
}

@media (max-width: 720px) {
    .tabela-lances {
        margin: 0;
    }

    .tabela-lances td:nth-of-type(1):before {
        content: "Sequência:";
    }

    .tabela-lances td:nth-of-type(2):before {
        content: "Descrição:";
    }

    .tabela-lances td:nth-of-type(3):before {
        content: "Situação:";
    }

    .tabela-lances td:nth-of-type(4):before {
        content: "Tempo:";
    }

    .tabela-lances td:nth-of-type(5):before {
        content: "Valor:";
    }

    .tabela-lances td:nth-of-type(6):before {
        content: "Enviar Valor:";
    }

    .tabela-lances td:nth-of-type(3) {
        text-align: left;
    }

    .tabela-lances td:nth-of-type(4) {
        text-align: left;
    }

    .tabela-lances td,
    .tabela-lances tr th,
    .tabela-lances tr {
        border: 0;
    }
}
</style>